import { CASINO_IMGIX, CDN_IMG_URL } from "../cdn";
import bitcasino from "./bitcasino";

const sportsbet: SiteConfig = {
  ...bitcasino,
  name: "Sportsbet",
  handle: "sportsbet",
  domain: "sportsbet.io",
  csEmail: "cs@sportsbet.io",
  defaultColorScheme: "dark",
  iconSetCdnPath: `${CDN_IMG_URL}/icons`,
  iconSetExt: ".svg",
  refCode: "sbseo",
  fontTypes: ["Averta Std"],
  privacyPolicyLink: "/about/privacy-policy",
  termsAndConditionsLink: "/about/terms-and-conditions",
  fullstoryAccountId: "BN5B8",
  pathPrefix: "/casino",
  isBridgeSite: true,
  menuItemsConfig: {
    common: {
      first: 12,
      filterName: "",
    },
  },
  convertComConfig: {
    isScriptEnabled: true,
    url: "https://cdn-4.convertexperiments.com/v1/js/100414391-10048779.js",
  },
  protoConfig: {
    gwId: "gw_UWVQAh7qlz9MSDHYjj1jd5Q",
  },
  isLoggedOutLiveChatEnabled: true,
  icons: {
    icon: [
      {
        url: `https://${CASINO_IMGIX}/bitcasino/images/sportsbet/favicons/favicon.ico`,
        sizes: "32x32",
        type: "image/png",
      },
    ],
    apple: [
      {
        url: `https://${CASINO_IMGIX}/bitcasino/images/sportsbet/favicons/apple-touch-icon-180x180.png`,
        sizes: "180x180",
      },
    ],
  },
  themeColor: "#0CD664",
  seo: {
    title: "general.title",
    description: "general.meta_description",
    og: {
      title: "og.title",
      description: "og.description",
      image: `https://${CASINO_IMGIX}/bitcasino/images/logo-sportsbet.png`,
    },
  },
  featurebaseOrganization: "sportsbet",
};

export default sportsbet;
